<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // H5页面不需要登录检查
    const hash = window.location.hash || ''
    const isH5Page = hash.includes('/h5/')
    console.log('App created, hash:', hash, 'isH5Page:', isH5Page)
    if (!isH5Page) {
      this.$store.dispatch('acCheckLogin')
    }
  },
  async mounted() {
    this.$nextTick(() => {
      this.setTitleFn()
    })
  },
  methods: {
    /**
     * 设置系统title与logo
     */
    setTitleFn() {
      const externalLinks = require('@/assets/json/externalLinks').default
      document.title = (externalLinks.company && externalLinks.company.companyName) ? externalLinks.company.companyName : '顺风侠城际出行管理平台'
      let link = document.getElementById('link')
      if (!link) {
        let head = document.getElementsByTagName('head')[0]
        link = document.createElement('link')
        link.id = 'link'
        link.rel = 'SHORTCUT ICON'
        head.appendChild(link)
      }
      // 使用配置文件中的favicon地址
      link.href = externalLinks.resources.favicon
    }
  }
}
</script>

<style lang="less">
#app {
  // 使用系统字体栈，确保跨平台一致性
  font-family: 
    -apple-system,           // macOS/iOS Safari
    BlinkMacSystemFont,      // macOS Chrome
    'Segoe UI',              // Windows
    Roboto,                  // Android/Chrome OS
    'PingFang SC',           // macOS/iOS 苹方
    'Hiragino Sans GB',      // macOS 冬青黑
    'Microsoft YaHei',       // Windows 微软雅黑
    '微软雅黑',              // Windows 微软雅黑（中文名）
    'Noto Sans SC',          // Google Noto 中文
    'Source Han Sans SC',    // 思源黑体
    'WenQuanYi Micro Hei',   // Linux 文泉驿微米黑
    'Helvetica Neue',
    Helvetica,
    Arial,
    sans-serif,
    'Apple Color Emoji',     // macOS/iOS Emoji
    'Segoe UI Emoji',        // Windows Emoji
    'Noto Color Emoji';      // Android/Linux Emoji
  
  // 字体渲染优化
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  
  // 布局
  width: 100%;
  height: 100%;
  
  // 行高和字重优化
  line-height: 1.5;
  font-weight: 400;
}

.driver-select {
  transform: translate(calc(100% + 30px), -49px) !important;
}

.driver-select.el-select-dropdown {
  .popper__arrow {
    transform: rotate(270deg);
    left: -10px !important;
    top: 20px !important;
  }
  
  // iOS 26 风格 - 旋转90度变成下三角形
  .popper__arrow::after {
    transform: rotate(90deg) !important;
  }
}

// iOS 26 全局 popper 箭头样式优化 - 使用主题色边框绘制三角形
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: @bg-color-lighter !important;
}
.el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: @color-primary !important;
}
.el-popper[x-placement^="left"] .popper__arrow::after {
  border-left-color: @color-primary !important;
}
.el-popper[x-placement^="right"] .popper__arrow::after {
  border-right-color: @color-primary !important;
}

input[aria-hidden="true"] {
    display: none !important;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none;
}


</style>
